import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.MainTagsCompetitionView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'tag_evolution'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  icon: 'table'

  initialize: (@options = {}) ->
    @specialLabel = 'Temáticas emergentes' # TODO: CAMBIAR POR Trámites Administrativos para que haya datos y poder probar

  _getCompetitors: ->
    return [] unless @getSpecificSettings().with_competition
    @options.settings.competitorsLabels

  render: ->
    @singleNode = @getSpecificSettings().singleNode || false
    @columns = ['Temática', @options.settings.accountLabel.description].concat(_.map(@_getCompetitors(), (label) -> label.description))
    @tableData = { columns: @columns, data: [], types: ['string'].concat(_.map(_.last(@columns), (c) -> 'number')), options: {} }
    @$el.html(@template(self: this))
    @requestsCompleted = 0
    @bindChartsReady(@columns.length - 1)
    @addChart()
    return this

  addChart: ->
    query = _.extend({ just_first_level: true }, @extendedQuery({labels: @options.settings.accountLabel.codes}), @getExtraQuery())
    @results = []
    @includedNodes = @specific_settings.includedNodes || []
    @includedNodes = _.union(@includedNodes, @options.settings.includedNodes || []) unless @singleNode
    $.post(@options.chartApi.hierarchy, query, (response) =>
      tags = if @singleNode
        foundLevel = _.find(response.levels, (level) => level.name == @singleNode)
        if foundLevel then foundLevel.children else response.levels
      else
        response.levels
      tags = _.filter(tags, (tag) => tag.name in @includedNodes) if @includedNodes.length > 0
      tags = _.sortBy(tags, (obj) -> -obj.y).slice(0, 5)
      # the childen of each element of 'tags' have names like 'parent node > something'
      # which need to be shown as 'something'
      if @singleNode
        _.each(tags, (tag) =>
          tag.name = tag.name.trim().replace(@singleNode + ' >', '').trim()
        )
      tags = tags.concat(@_getChildrenOf(response.levels, @specialLabel))
      @results.push { label: @options.settings.accountLabel.description, tags: tags }
      @_onSuccess()

      tagNames = _.map(tags, (tag) -> tag.name)
      _.each(@_getCompetitors(), (competitor) =>
        query = _.extend({ just_first_level: true }, @extendedQuery({labels: competitor.codes}), @getExtraQuery())
        $.post(@options.chartApi.hierarchy, query, ((competitor) =>
          (response) =>
            tags2 = response.levels
            tags2 = _.filter(tags2, (tag) => tag.name in @includedNodes) if @includedNodes.length > 0
            @results.push { label: competitor.description, tags: @_tagsForCompetitors(tags2, tagNames) }
            @_onSuccess()
          )(competitor)
        )
      )
    )

  _tagsForCompetitors: (responseTags, columnTags) ->
    tags = []
    allTags = responseTags.concat(@_getChildrenOf(responseTags, @specialLabel))
    for name in columnTags
      if (element = _.find(allTags, (tag) -> tag.name == name))
        tags.push element
    tags

  _onSuccess: ->
    @requestsCompleted++
    @chartReady('.chart_container')
    @_drawTable() if @requestsCompleted == @columns.length - 1

  _drawTable: ->
    matrix = []
    for result in @results
      matrix[@columns.indexOf(result.label) - 1] = result.tags

    for row in @_transpose(matrix)
      @tableData.data.push [row[0].name].concat(_.map(row, (tag) => tag.y))

    @tableData.columns[1] = 'Menciones' unless @getSpecificSettings().with_competition
    @$el.find('.chart_container').html(new Monitoring.Reports.Executive.TableView(response: @tableData).render().el)

  _transpose: (matrix) ->
    _.zip.apply(_, matrix)

  _getChildrenOf: (list, name) ->
    element = _.find(list, (label) -> label.name == name)
    return [] unless element
    _.sortBy(_.reject(element.children, (obj) => !@getSpecificSettings().with_competition && obj.y == 0), (obj) -> -obj.y)
